import {
    addAttendeeFromEmailAddress,
    updateRequiredAttendees,
} from 'owa-calendar-compose-form-actions';
import { getRecipientsFromRequiredAttendees } from 'owa-calendar-compose-form-store/lib/utils/getRecipientsFromAttendees';
import { convertRecipientsToAttendees } from 'owa-calendar-forms-utils/lib/utils/recipientAttendeeConversions';
import { getReadWriteRecipientViewStateFromRecipientAddressString } from 'owa-recipient-create-viewstate/lib/util/getReadWriteRecipientViewStateFromRecipientAddressString';
import type AttendeeType from 'owa-service/lib/contract/AttendeeType';
import { orchestrator } from 'satcheljs';

export default orchestrator(addAttendeeFromEmailAddress, actionMessage => {
    const { emailAddress, formId } = actionMessage;
    const recipients = getRecipientsFromRequiredAttendees(formId);
    const recipientPresent = recipients.some(recipient => {
        return (
            recipient.persona.EmailAddress.EmailAddress === emailAddress ||
            getFormattedImAddress(recipient.persona.ImAddress) === emailAddress
        );
    });
    if (!recipientPresent) {
        recipients.push(getReadWriteRecipientViewStateFromRecipientAddressString(emailAddress));
        const attendees: AttendeeType[] = convertRecipientsToAttendees(recipients);
        updateRequiredAttendees(attendees, formId);
    }
});

function getFormattedImAddress(imAddress: string) {
    if (!imAddress || imAddress.length === 0) {
        return '';
    }

    // imAddress format is sip:zzz@yyy.com
    const splitImAddressArr = imAddress.split('sip:');

    if (splitImAddressArr.length == 2) {
        return splitImAddressArr[1];
    }

    return '';
}
